import dayjs from 'dayjs';
import { COLORS as C, RADIUS } from '../constants/ui';

/**
 * The Daily Notebook's ETA control, extracted so work-item creation offers the
 * same shortcuts. An ETA is how this product measures commitment, so it is
 * quick to set rather than buried behind a date picker.
 *
 * `value`/`onChange` speak plain "YYYY-MM-DD" strings (or '' for none), which
 * is what the issues API takes — callers don't deal in dayjs objects.
 */
const PRESETS = [
  { label: 'Today', days: 0 },
  { label: '+1d', days: 1 },
  { label: '+3d', days: 3 },
  { label: '+7d', days: 7 },
];

export default function EtaQuickPicker({ value, onChange, disabled = false }) {
  const today = dayjs().startOf('day');
  const selected = value ? dayjs(value) : null;

  const chipStyle = (active) => ({
    padding: '5px 11px',
    borderRadius: RADIUS.control,
    border: `1px solid ${active ? C.accentInk : C.line}`,
    background: active ? C.accentInk : '#fff',
    color: active ? '#fff' : C.inkSoft,
    fontSize: '0.75rem',
    fontWeight: 700,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    whiteSpace: 'nowrap',
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      {PRESETS.map((p) => {
        const date = today.add(p.days, 'day');
        const active = selected ? selected.isSame(date, 'day') : false;
        return (
          <button
            key={p.label}
            type="button"
            disabled={disabled}
            aria-pressed={active}
            onClick={() => onChange(date.format('YYYY-MM-DD'))}
            style={chipStyle(active)}
          >
            {p.label}
          </button>
        );
      })}
      <input
        type="date"
        value={value || ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        aria-label="ETA date"
        style={{
          padding: '5px 8px',
          borderRadius: RADIUS.control,
          border: `1px solid ${C.line}`,
          fontSize: '0.75rem',
          color: C.inkSoft,
          background: '#fff',
        }}
      />
      {value && (
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange('')}
          style={{
            background: 'none',
            border: 'none',
            color: C.inkFaint,
            fontSize: '0.72rem',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          clear
        </button>
      )}
    </div>
  );
}
